import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';
import AuthShell from '../../ui/AuthShell';
import Card from '../../ui/Card';
import { getAuth, confirmPasswordReset } from 'firebase/auth';
import './auth.css'; // Import the CSS file

const ResetPassword = () => {
  const [reset, setReset] = useState(false);
  const auth = getAuth();
  const location = useLocation();
  const actionCode = new URLSearchParams(location.search).get('oobCode');

  const onFinish = async (values) => {
    if (values.password !== values.confirmPassword) {
      message.error('Passwords do not match.');
      return;
    }
    try {
      await confirmPasswordReset(auth, actionCode, values.password);
      setReset(true);
      message.success('Password has been reset successfully!');
    } catch (error) {
      message.error('Failed to reset password. The link may be expired or invalid.');
    }
  };

  return (
    <AuthShell>
      <Card className="auth-form-wrapper" style={{ padding: 24 }}>
        <div className="auth-header" style={{ textAlign: 'center', marginBottom: 8 }}>
          <h2 style={{ margin: '12px 0 6px', fontWeight: 700, color: '#0f172a' }}>Set a new password</h2>
          <p style={{ margin: 0, color: '#334155' }}>Choose a secure password for your account.</p>
        </div>
        {!reset ? (
          <Form name="reset-password" onFinish={onFinish} layout="vertical">
            <Form.Item name="password" label="New password" rules={[{ required: true, message: 'Please enter your new password!' }]}>
              <Input.Password size="large" placeholder="Enter your new password" />
            </Form.Item>
            <Form.Item name="confirmPassword" label="Confirm password" rules={[{ required: true, message: 'Please confirm your new password!' }]}>
              <Input.Password size="large" placeholder="Confirm your new password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="auth-form-button signin-button" size="large" style={{ backgroundColor: '#004d54', borderColor: '#004d54', boxShadow: '0 6px 16px rgba(0,77,84,0.24)' }}>
                Reset password
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <p>Your password has been reset. You can now <Link to="/auth/login" className="auth-form-link">sign in</Link> with your new password.</p>
          </div>
        )}
      </Card>
    </AuthShell>
  );
};

export default ResetPassword;
